import { createResource } from 'react-resource-router';

import { getCustomRolesListEndpoint } from '../custom-role/endpoints';

export const customRolesResource = createResource({
	type: 'rolesResource',
	getKey: () => 'rolesResource',
	getData: getCustomRolesListEndpoint,
	isBrowserOnly: true,
});

export const resources = () => [customRolesResource];
